/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.onboarding.tours.rpc.ToursRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './ToursRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.onboarding.tours.rpc.ToursRpc#getTours
 */
export const GET_TOURS_QUERY_FIELD_NAME = 'com_hubspot_onboarding_tours_rpc_ToursRpc_getTours';
export const GET_TOURS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TOURS_QUERY_FIELD_NAME,
  args: ['status'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getToursRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.onboarding.tours.rpc.ToursRpc#getTour
 */
export const GET_TOUR_QUERY_FIELD_NAME = 'com_hubspot_onboarding_tours_rpc_ToursRpc_getTour';
export const GET_TOUR_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TOUR_QUERY_FIELD_NAME,
  args: ['tourKey', 'isUserScoped'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getTourRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.onboarding.tours.rpc.ToursRpc#upsertTour
 */
export const UPSERT_TOUR_MUTATION_FIELD_NAME = 'com_hubspot_onboarding_tours_rpc_ToursRpc_upsertTour';
export const UPSERT_TOUR_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPSERT_TOUR_MUTATION_FIELD_NAME,
  args: ['tourKey', 'status'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.upsertTourRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.onboarding.tours.rpc.ToursRpc#deleteTour
 */
export const DELETE_TOUR_MUTATION_FIELD_NAME = 'com_hubspot_onboarding_tours_rpc_ToursRpc_deleteTour';
export const DELETE_TOUR_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_TOUR_MUTATION_FIELD_NAME,
  args: ['tourKey'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.deleteTourRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});